
<div class="preloader-wrapper {{ className }}" *ngIf="isShow" [ngClass]="{ 		&quot;preloader-wrapper--top_aligned&quot;: ctrlLoaderTopAligned, 		&quot;preloader-wrapper--with_overlay&quot;: ctrlLoaderWithOverlay 	}">
  <div [attr.class]="&quot;preloader-container &quot; + ctrlLoaderClasses">
    <div class="spinner-layer">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div>
      <div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>
  <div class="preloader-label" *ngIf="label">{{ label }}</div>
</div>